import React, { useState, useEffect, memo } from 'react';
import classes from './Navbar.module.css';
import { Link } from 'react-router-dom';
import NavList from './NavList';
// import logo from "../../Assets/Memoji/Om.png";

const Navbar = () => {
  const [isActive, setActive] = useState(false);
  const [isVisible, setIsVisible] = useState(true);

  const disableScroll = () => {
    document.body.classList.toggle('stop-scrolling');
  };

  const listenToScroll = () => {
    // let heightToHideFrom = window.innerHeight;
    let heightToHideFrom = 400;
    const winScroll =
      document.body.scrollTop || document.documentElement.scrollTop;

    if (winScroll > heightToHideFrom) {
      isVisible && // to limit setting state only the first time
        setIsVisible(false);
    } else {
      setIsVisible(true);
    }
  };
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    window.addEventListener('scroll', listenToScroll);
    return () => window.removeEventListener('scroll', listenToScroll);
  }, []);

  const navHandler = () => {
    setActive(!isActive);
    disableScroll();
  };
  return (
    <>
      {isVisible && (
        <div id="hide">
          <nav
            className={`${classes.nav} ${
              isActive ? `${classes.active} ${classes.navfixed}` : ''
            }`}
          >
            <Link to="/" className={classes.logo}>
              <span className={classes.angular}>&lt;</span>
              <span className={`${classes.initials} ${classes.initialo}`}>
                O
              </span>
              <span className={classes.angularslash}>/</span>
              <span className={`${classes.initials} ${classes.initialg}`}>
                G
              </span>
              <span className={classes.angular}>&gt;</span>
              {/* <img
              src={logo}
              alt="logo"
              style={{ width: "100px", paddingTop: "40px" }}
            /> */}
            </Link>
            <div className={classes.btn}>
              <button className={classes.icon} onClick={navHandler}>
                <span className={classes.line + ' ' + classes.line1}></span>
                <span className={classes.line + ' ' + classes.line2}></span>
              </button>
            </div>
          </nav>
          {isActive && <NavList onClick={navHandler} />}
        </div>
      )}
    </>
  );
};

export default memo(Navbar);
